import axios from 'axios';
import { B2C_ADDRESSES_PATH, OG_UPDATE_ADDRESS_PROD_URL, OG_UPDATE_ADDRESS_QA_URL, } from '../../constants/links';
import { apiB2C } from '../axios-client';
import { isProd } from '../../utils/environments';
import { getOrderGrooveAddressPayload } from '../../utils/order-groove';
const postOrderGrooveAddressRequest = (address) => axios.post(isProd() ? OG_UPDATE_ADDRESS_PROD_URL : OG_UPDATE_ADDRESS_QA_URL, getOrderGrooveAddressPayload(address), { headers: { 'Content-Type': 'text/plain;charset=UTF-8' } });
const updateOrderGrooveAddress = (addresses) => {
    var _a, _b;
    const newDefaultAddress = (_b = (_a = addresses === null || addresses === void 0 ? void 0 : addresses.addresses) === null || _a === void 0 ? void 0 : _a.address) === null || _b === void 0 ? void 0 : _b.find((address) => address.isDefault);
    if (newDefaultAddress === null || newDefaultAddress === void 0 ? void 0 : newDefaultAddress.isDefault) {
        postOrderGrooveAddressRequest(newDefaultAddress);
    }
};
export const b2cAddressesApi = {
    getDefaultAddress: () => apiB2C.get(B2C_ADDRESSES_PATH, {
        params: {
            pageSize: 0,
            pageNumber: 0,
        },
    }),
    addNewAddress: (address) => apiB2C
        .post(B2C_ADDRESSES_PATH, {
        addresses: {
            address: [address],
        },
    })
        .then((response) => {
        updateOrderGrooveAddress(response.data);
        return response;
    }),
    deleteAddress: ({ addrIdentifier, lastModifiedDate, }) => apiB2C.delete(`${B2C_ADDRESSES_PATH}/${addrIdentifier}`, {
        params: {
            lastModifiedDate,
        },
    }),
    editAddress: (...addresses) => apiB2C
        .put(B2C_ADDRESSES_PATH, {
        addresses: {
            address: addresses,
        },
    })
        .then(({ data }) => {
        updateOrderGrooveAddress(data);
        return data;
    }),
    getAllAddresses: () => apiB2C.get(B2C_ADDRESSES_PATH, {
        params: {
            pageSize: 0,
            pageNumber: 0,
        },
    }),
};
